import { useState } from "react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import Card from "../components/ui/Card";
import Input from "../components/ui/Input";
import Button from "../components/ui/Button";
import { Parse } from "../lib/parse";

function ForgetPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      await Parse.User.requestPasswordReset(email.trim().toLowerCase());
      setSuccess(
        t("new-ui.forgot-password.success-message", {
          defaultValue: "If the account exists, a password reset email was sent."
        })
      );
    } catch (submitError) {
      console.error("Password reset error", submitError);
      setError(
        submitError?.message ||
          t("new-ui.forgot-password.error-message", {
            defaultValue: "Could not request password reset. Verify backend is running and try again."
          })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-app-paper px-4 py-10 md:px-8">
      <div className="mx-auto max-w-xl">
        <Card className="animate-fade-up">
          <p className="ui-kicker">{t("new-ui.forgot-password.kicker", { defaultValue: "DigiCert account recovery" })}</p>
          <h1 className="ui-title mt-2 text-xl">{t("new-ui.forgot-password.title", { defaultValue: "Forgot your password?" })}</h1>
          <p className="ui-copy mt-3">
            {t("new-ui.forgot-password.description", {
              defaultValue: "Enter your email and we will send a reset link."
            })}
          </p>

          <form className="mt-6 space-y-4" onSubmit={onSubmit}>
            <Input
              id="recovery-email"
              label={t("email", { defaultValue: "Email" })}
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />

            {error ? <p className="text-sm text-app-danger">{error}</p> : null}
            {success ? <p className="text-sm text-app-teal">{success}</p> : null}

            <div className="flex flex-wrap gap-2">
              <Button type="submit" disabled={loading}>
                {loading
                  ? t("new-ui.forgot-password.sending", { defaultValue: "Sending..." })
                  : t("new-ui.forgot-password.send-reset-link", { defaultValue: "Send reset link" })}
              </Button>
              <Link to="/">
                <Button type="button" variant="ghost">
                  {t("new-ui.forgot-password.back-to-login", { defaultValue: "Back to login" })}
                </Button>
              </Link>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
}

export default ForgetPasswordPage;
